import { SVGProps, Ref, forwardRef } from 'react'
const SvgLightBulb = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.5 22.5h3M18 12a6 6 0 1 0-7.5 5.788V19.5h3v-1.712A5.986 5.986 0 0 0 18 12v0ZM12 3V1.5M21 10.5h1.5M1.5 12H3M18.363 17.614l1.061 1.061M4.574 3.825l1.061 1.061M18.363 4.886l1.061-1.061M4.574 18.675l1.061-1.061"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgLightBulb)
export default ForwardRef
